// hooks/useCloseModalsOnRouteChange.ts
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { REQUIRE_EMAIL_MODAL_ID } from '@/app/entities/me/ui/requireEmailModal.constants'

export const useCloseModalsOnRouteChange = () => {
    const location = useLocation()

    useEffect(() => {
        // Закрыть все модальные окна (checkbox-based), кроме controlled require-email
        const modals = document.querySelectorAll('.modal-toggle') as NodeListOf<HTMLInputElement>
        modals.forEach(modal => {
            if (modal.id === REQUIRE_EMAIL_MODAL_ID) return
            modal.checked = false
        })

        // Закрыть все выпадающие меню
        const dropdowns = document.querySelectorAll('.drawer-toggle') as NodeListOf<HTMLInputElement>
        dropdowns.forEach(dropdown => {
            dropdown.checked = false
        })
    }, [location.pathname])
}
